// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"YPkyH","revampWrapper":"juJz6","cardOuter":"_30Ehx"};